import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import type { KeyboardEvent, ReactNode, Ref } from 'react';
import { ONBOARDING_PANEL_ID } from '../../../../constants';
import type { IntentHandlers } from '../../../../hooks/use-prefetch-onboardings';
type OnboardingStripItemProps = {
  id: string;
  isSelected: boolean;
  intentHandlers?: IntentHandlers;
  onClick: () => void;
  onKeyDown: (event: KeyboardEvent<HTMLButtonElement>) => void;
  ref: Ref<HTMLButtonElement>;
  children: ReactNode;
};
const OnboardingStripItem = t0 => {
  const $ = _c(12);
  const {
    id,
    isSelected,
    intentHandlers,
    onClick,
    onKeyDown,
    ref,
    children
  } = t0;
  const t1 = isSelected ? 0 : -1;
  const t2 = isSelected ? "border-tertiary bg-primary" : "border-transparent hover:bg-hover";
  let t3;
  if ($[0] !== t2) {
    t3 = cx("flex w-full cursor-pointer rounded-default border border-solid px-2.5 py-2 transition-[scale] duration-100 active:scale-pressed motion-reduce:active:scale-100 focus-visible:outline focus-visible:-outline-offset-1 focus-visible:outline-primary", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== id || $[4] !== intentHandlers || $[5] !== isSelected || $[6] !== onClick || $[7] !== onKeyDown || $[8] !== ref || $[9] !== t1 || $[10] !== t3) {
    t4 = <button {...intentHandlers} ref={ref} id={id} type="button" role="tab" aria-selected={isSelected} aria-controls={ONBOARDING_PANEL_ID} tabIndex={t1} className={t3} onClick={onClick} onKeyDown={onKeyDown}>{children}</button>;
    $[2] = children;
    $[3] = id;
    $[4] = intentHandlers;
    $[5] = isSelected;
    $[6] = onClick;
    $[7] = onKeyDown;
    $[8] = ref;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default OnboardingStripItem;